import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { Card, CardContent, Divider } from '@mui/material';
import Language from '../../components/Language/Language';
import image from "../../images/graph.png"
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { ConfirmPassword, Password } from '../../components/TextBox';

export default function ChangePassword() {

    const navigate = useNavigate();
    const handleLogin = () => {
        navigate('/login')
    }

    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')

    const contentRegister = (
        <>
            <Box sx={{ display: "flex", aligntItems: "center", justifyContent: "space-between", mt: 2, mb: 3 }}>
                <Box sx={{ display: "flex", alignItems: "center", }}>
                    <Avatar sx={{ m: 1, backgroundColor: "#2196f3" }}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Change Password
                    </Typography>
                </Box>
                <Box>
                    <Language />
                </Box>
            </Box>


            <Grid container display="flex" justifyContent="space-between" alignItems="center" mb={3} spacing={2}>
                <Grid item xs={12}>
                    <Password />
                </Grid>
                <Grid item xs={12}>
                    <Password password={password} setPassword={setPassword} />
                </Grid>
                <Grid item xs={12}>
                    <ConfirmPassword confirmPassword={confirmPassword} setConfirmPassword={setConfirmPassword} />
                </Grid>
            </Grid>

            <Divider />

            <Grid container display="flex" alignContent="space-around" justifyContent="center" mt={2}>
                <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }} mt={4}>
                    <Button
                        type="submit"
                        variant="contained"
                        sx={{ width: 250 }}
                    >
                        Submit
                    </Button>
                </Grid>
            </Grid>
        </>
    )

    const contentText = (<>
        <img
            alt="Under development"
            src={image}
            style={{
                position: 'absolute',
                zIndex: -1,
                top: -250,
                left: -110,
                opacity: "10%",

            }}
        />
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 150 }}>
            <Typography variant='h4' sx={{ color: "white" }}>Sola Soft</Typography>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 150 }}>
            <Typography variant='subtitle1' sx={{ color: "white", textAlign: "center" }}>We do not promise, We make things Possible!</Typography>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "flex-end", height: 100 }}>
            <Typography variant='subtitle1' sx={{ color: "white", textAlign: "center" }}></Typography>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "flex-end", height: 60 }}>
            <Button variant="outlined" sx={{ color: "white" }} onClick={handleLogin}>
                Login
            </Button>
        </Box>
    </>
    )

    return (


        <div className='animation-bg'>

            <Grid container width={{ xs: 400, sm: 400, md: 800 }}>
                <Grid item sx={{ display: { xs: "none", sm: "none", md: "block" }, }} md={4} lg={4} xl={4} >
                    <Card sx={{ zIndex: 2, position: "relative", backgroundColor: "#2196f3", height: 500 }} >
                        <CardContent>
                            {contentText}
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                    <Card sx={{ zIndex: 2, position: "relative", height: 500 }} >
                        <CardContent>
                            {contentRegister}
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
            <div>
                <div className="wave"></div>
                <div className="wave"></div>
                <div className="wave"></div>
            </div>
        </div>
    );
}
